import { addNewProjectConstants } from "../constant/addNewProject.constants";

export const initialState = {
    dataAddNewProject: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const addNewProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case addNewProjectConstants.GET_SUCCESS:
            return {
                ...state,
                errorCode: action.addNewProjectList.error_code,
                dataAddNewProject: action.addNewProjectList
            }; 
        default:
            return state;
    }

};

export default addNewProjectReducer;
